import { format } from "date-fns";
import * as Yup from "yup";

export const contractShipmentDeliveryFormSchema = Yup.object({
  receivedAt: Yup.string()
    .required("Informe a data de entrega.")
    .test(
      "not-future",
      "A data de entrega não pode ser futura.",
      value => value <= format(new Date(), "yyyy-MM-dd")
    )
});
